import * as React from 'react';

/**
 * Interface that must be implemented by any component that provides Structured Data.
 * Example:
 * - Breadcrumbs
 */
export interface StructuredData {
  stringOfStructuredData: () => string;
}

export interface SchemaOrgScriptProps {
  structuredData: StructuredData;
}

/**
 * Adds schema.org structured data on to the page
 */
export class SchemaOrgScript extends React.PureComponent<SchemaOrgScriptProps> {
  public render() {
    const { structuredData } = this.props;

    if (!structuredData) {
      return null;
    }

    const toRender = structuredData.stringOfStructuredData();
    if (!toRender) {
      return null;
    }

    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: toRender }} />;
  }
}
